/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetSmsTemplateByIdDto } from '../models/custom-result-of-get-sms-template-by-id-dto';
import { CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-sms-templates-with-pagination-dto';
import { smsTemplatesCreateGet } from '../fn/sms-templates/sms-templates-create-get';
import { SmsTemplatesCreateGet$Params } from '../fn/sms-templates/sms-templates-create-get';
import { smsTemplatesCreatePost } from '../fn/sms-templates/sms-templates-create-post';
import { SmsTemplatesCreatePost$Params } from '../fn/sms-templates/sms-templates-create-post';
import { smsTemplatesDelete } from '../fn/sms-templates/sms-templates-delete';
import { SmsTemplatesDelete$Params } from '../fn/sms-templates/sms-templates-delete';
import { smsTemplatesGetSmsTemplatesAudit } from '../fn/sms-templates/sms-templates-get-sms-templates-audit';
import { SmsTemplatesGetSmsTemplatesAudit$Params } from '../fn/sms-templates/sms-templates-get-sms-templates-audit';
import { smsTemplatesGetSmsTemplatesWithPagination } from '../fn/sms-templates/sms-templates-get-sms-templates-with-pagination';
import { SmsTemplatesGetSmsTemplatesWithPagination$Params } from '../fn/sms-templates/sms-templates-get-sms-templates-with-pagination';
import { smsTemplatesUpdateGet } from '../fn/sms-templates/sms-templates-update-get';
import { SmsTemplatesUpdateGet$Params } from '../fn/sms-templates/sms-templates-update-get';
import { smsTemplatesUpdatePut } from '../fn/sms-templates/sms-templates-update-put';
import { SmsTemplatesUpdatePut$Params } from '../fn/sms-templates/sms-templates-update-put';

@Injectable({ providedIn: 'root' })
export class SmsTemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smsTemplatesCreateGet()` */
  static readonly SmsTemplatesCreateGetPath = '/SmsTemplates/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesCreateGet$Response(params?: SmsTemplatesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smsTemplatesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesCreateGet(params?: SmsTemplatesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smsTemplatesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smsTemplatesCreatePost()` */
  static readonly SmsTemplatesCreatePostPath = '/SmsTemplates/Create';

  /**
   * Create SmsTemplate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesCreatePost$Response(params: SmsTemplatesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplatesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create SmsTemplate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesCreatePost(params: SmsTemplatesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplatesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplatesGetSmsTemplatesWithPagination()` */
  static readonly SmsTemplatesGetSmsTemplatesWithPaginationPath = '/SmsTemplates/GetSmsTemplatesWithPagination';

  /**
   * For each user get SmsTemplates with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesGetSmsTemplatesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesGetSmsTemplatesWithPagination$Response(params: SmsTemplatesGetSmsTemplatesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto>> {
    return smsTemplatesGetSmsTemplatesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get SmsTemplates with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesGetSmsTemplatesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesGetSmsTemplatesWithPagination(params: SmsTemplatesGetSmsTemplatesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto> {
    return this.smsTemplatesGetSmsTemplatesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto>): CustomResultOfPaginatedListOfGetSmsTemplatesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `smsTemplatesDelete()` */
  static readonly SmsTemplatesDeletePath = '/SmsTemplates/{id}';

  /**
   * Delete SmsTemplate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesDelete$Response(params: SmsTemplatesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplatesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete SmsTemplate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesDelete(params: SmsTemplatesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplatesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplatesUpdateGet()` */
  static readonly SmsTemplatesUpdateGetPath = '/SmsTemplates/Update';

  /**
   * Get SmsTemplate ById for edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesUpdateGet$Response(params?: SmsTemplatesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSmsTemplateByIdDto>> {
    return smsTemplatesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get SmsTemplate ById for edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplatesUpdateGet(params?: SmsTemplatesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetSmsTemplateByIdDto> {
    return this.smsTemplatesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSmsTemplateByIdDto>): CustomResultOfGetSmsTemplateByIdDto => r.body)
    );
  }

  /** Path part for operation `smsTemplatesUpdatePut()` */
  static readonly SmsTemplatesUpdatePutPath = '/SmsTemplates/Update';

  /**
   * Update SmsTemplate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesUpdatePut$Response(params: SmsTemplatesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplatesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update SmsTemplate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesUpdatePut(params: SmsTemplatesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplatesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplatesGetSmsTemplatesAudit()` */
  static readonly SmsTemplatesGetSmsTemplatesAuditPath = '/SmsTemplates/GetSmsTemplatesAudit';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplatesGetSmsTemplatesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesGetSmsTemplatesAudit$Response(params: SmsTemplatesGetSmsTemplatesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return smsTemplatesGetSmsTemplatesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplatesGetSmsTemplatesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplatesGetSmsTemplatesAudit(params: SmsTemplatesGetSmsTemplatesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.smsTemplatesGetSmsTemplatesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
